import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { canAccessPath, firstAccessiblePath } from './permissions';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [hasAccess, setHasAccess] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('adminToken');
      
      if (!token) {
        setIsValid(false);
        setChecking(false);
        return;
      }

      // Check if user has permission for this specific route
      const user = JSON.parse(localStorage.getItem('adminUser') || '{}');
      const permitted = canAccessPath(user, location.pathname);
      
      setHasAccess(permitted);
      setIsValid(true);
      setChecking(false);
    };

    checkAuth();
  }, [location.pathname]);

  // Show loading spinner while checking
  if (checking) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-red-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isValid) {
    return <Navigate to="/admin/login" replace />;
  }

  // If user doesn't have access to this route, redirect to their first accessible page
  if (!hasAccess) {
    const user = JSON.parse(localStorage.getItem('adminUser') || '{}');
    return <Navigate to={firstAccessiblePath(user)} replace />;
  }

  return children;
};

export default ProtectedRoute;
